import { createAppFormHook } from '@pkg/form/createAppFormHook'
import { ContactGroupField } from './group/ContactGroupField'
import { ContactPersonField } from './group/ContactPersonField'
import { PersonalGroupField } from './group/PersonalGroupField'
import { StationField } from './group/StationField'
import { ValidPeriodGroupField } from './group/ValidPeriodGroupField'

const fieldComponents = {
  ContactPerson: ContactPersonField,
  Station: StationField,
  ContactGroup: ContactGroupField,
  Personal: PersonalGroupField,
  ValidPeriod: ValidPeriodGroupField,
} as const

export const { useAppForm, withForm, useAppFormContext, withFieldGroup, extendForm } = createAppFormHook({
  fieldComponents,
})
